<template>
	<div class="page">
		<div class="screenLine">
			<el-input v-model="params.keyword" @keyup.enter.native="changeSearch" placeholder="输入关键字" style="width:240px;margin-right: 16px;"></el-input>
			<div class="screenLineR">
				<el-button icon="el-icon-plus" type="warning" @click='addGoods()' size="small">新建商品</el-button>
			</div>
		</div>
		<div class="pageConBox">
			<div class="left" style="overflow-y: scroll;">
				<el-button style="margin-left: 20px;" size="mini" @click="addProductType('')">添加</el-button>
				<el-button size="mini" type="warning" @click="resetProductType">重置</el-button>
				<el-tree class="elTree" style="margin-top: 10px;height: 800px;" :data="categoryList" :highlight-current='true' node-key="id" default-expand-all :expand-on-click-node="false" :render-content="renderContent" @node-click='clickProductType' ref="tree">
				</el-tree>
			</div>
			<div class="table" >
				<div class="tableBox">
					<el-table :data="tableData" style="width: 100%;" height="100%" size="small">
						<el-table-column prop="title" label="名称" >
							<template slot-scope="scope">
								<div v-if="$public.isNull(scope.row.cover)">{{scope.row.title}} {{scope.row.buy_back == 0?'不复购':'复购'}}</div>
								<el-tooltip v-else placement="top" effect="light">
									<div slot="content">
										<img :src="scope.row.cover"  style="width:300px;"/>
									</div>
									<div>{{scope.row.title}} {{scope.row.buy_back == 0?'不复购':'复购'}}</div>
								</el-tooltip>
							</template>
						</el-table-column>
						<el-table-column prop="name" label="适用宠物" width="80">
							<template slot-scope="scope">
								<span>{{scope.row.apply_type.title}}</span>
							</template>
						</el-table-column>
						<el-table-column label="品牌" width="80">
							<template slot-scope="scope">
								<span>{{scope.row.brand_name}}</span>
							</template>
						</el-table-column>
						<el-table-column label="分类" width="100">
							<template slot-scope="scope">
								<span>{{scope.row.category_info.name}}</span>
							</template>
						</el-table-column>
						<el-table-column label="操作" width="180">
							<template slot-scope="scope">
								<el-button type="text" size="small" @click='uploadImg(scope.row)'>上传图片</el-button>
								<el-button type="text" icon='el-icon-edit' size="small" @click='edit(scope.row.goodsId)'>编辑</el-button>
								<el-button type="text" icon='el-icon-delete' size="small" @click='deleted(scope.row.goodsId)'>删除</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div class="pagePosi">
					<page style="padding:10px 0;" :page="page.page" :total="page.total" :pageSize="page.pageSize" @change="changePage"></page>
				</div>
			</div>
		</div>
		<el-dialog title="商品类型设置" :visible.sync="dialogProductType" width="30%" :close-on-click-modal='false' :close-on-press-escape="false" :wrapperClosable="false" :modal-append-to-body="false">
			<el-form ref="editProductParams" label-width="80px">
				<el-form-item label="类型名称">
					<el-input v-model="editProductParams.typeName" size='mini' style="width: 200px;"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button size="small" type="warning" @click="submitProductType">确定</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		
		<el-dialog v-if="dialogUploadImg_state" title="上传图片" :visible.sync="dialogUploadImg_state" width="60%" :close-on-click-modal='false' top="5vh" :close-on-press-escape="false" :wrapperClosable="false" :modal-append-to-body="false">
			<el-form ref="dialogUploadImgRef" label-width="80px">
				<el-form-item label="主图:">
					<uploadImg :fileLists="fileLists1" :num="1" @sendImg="sendImg1"></uploadImg>
				</el-form-item>
				<el-form-item label="规格:">
					<div>
						<div style="border-bottom:1px solid #ccc;padding-bottom:10px;" v-for="(skuItem,skuIndex) in uploadImgParams.skuImages" :key="skuItem.skuId">
							{{skuIndex+1}}、{{skuItem.skuName}}
							<uploadImg style="display: inline-block;margin-left:5px;" :remark="skuItem.skuId" :fileLists="fileLists2[skuIndex]" :num="5"  @sendImg="sendImg2"></uploadImg>
						</div>
					</div>
				</el-form-item>
				<el-form-item label="详情:">
					<uploadImg :fileLists="fileLists3" :num="5"  @sendImg="sendImg3"></uploadImg>
				</el-form-item>
				<el-form-item style="text-align: center;">
					<el-button style="width:100px;" size="small" type="warning" @click="submit_dialogUploadImg">确定</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>

	</div>
</template>

<script>
	import page from "../../../components/page.vue"
	import uploadImg from "../../../components/uploadImg.vue"
	export default {
		components: { page,uploadImg },
		data() {
			return {
				params: {
					keyword: '',
					categoryId: '',
					shopId: '',
				},
				
				page: {
					page: 1,
					pageSize: 10,
					total: 0
				},
				tableData: [],
				
				// 三级分类树
				categoryList: [],
				dialogProductType: false,
				editProductParams: {
					category: '商品',
					typeId:'',
					typeName: '',
					parentId: '',
				},
				
				// 上传图片
				dialogUploadImg_state:false,
				uploadImgParams:{},
				fileLists1:[],
				fileLists2:[],
				fileLists3:[],
			}
		},
		created() {
			this.getTableData();
			this.getTree()
		},
		methods: {
			addGoods() {
				this.$router.push({ path: '/product/addgoods'})
			},
			edit(id) {
				this.$router.push({ path: '/product/addgoods?id='+id})
			},
			deleted(id) {
				this.$confirm('此操作将永久删除该条数据, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.delete(process.env.VUE_APP_baseData+'/api/product/goods', {id}).then(res => {
						if (res.code == 0) {
							this.$message({
								type: 'success',
								message: '删除成功!'
							});
							this.getTableData();
						}
					})
				})
			},
			// 上传图片
			uploadImg(row){
				let loading = this.$loading()
				this.$http.get(process.env.VUE_APP_baseData+'/api/product/goods/images', {prouctId:row.goodsId}).then(res => {
					loading.close()
					if (res.code == 0) {
						let d = res.data;
						this.uploadImgParams = d;
						
						this.fileLists1 = []
						if(!this.$public.isNull(d.cover)){
							this.fileLists1 = [{url:d.cover, name:d.cover.substr(d.cover.length-21)}];
						}
						this.fileLists2 = []
						if(!this.$public.isNull(d.skuImages)){
							for(let i=0;i<d.skuImages.length;i++){
								let arr = []
								if(!this.$public.isNull(d.skuImages[i].image)){
									for(let a=0;a<d.skuImages[i].image.length;a++){
										arr.push({url:d.skuImages[i].image[a], name:d.skuImages[i].image[a].substr(d.skuImages[i].image[a].length-21)})
									}
								}
								this.fileLists2.push(arr)
							}
						}
						this.fileLists3 = []
						if(!this.$public.isNull(d.detailImgList)){
							for(let i=0;i<d.detailImgList.length;i++){
								this.fileLists3.push({url:d.detailImgList[i], name:d.detailImgList[i].substr(d.detailImgList[i].length-21)})
							}
						}
						
						this.dialogUploadImg_state = true;
					}
				})
			},
			sendImg1(list){
				this.uploadImgParams.cover = list[0].url;
			},
			sendImg2(list,str){
				for(let i=0;i<this.uploadImgParams.skuImages.length;i++){
					if(this.uploadImgParams.skuImages[i].skuId === str){
						this.uploadImgParams.skuImages[i].image = []
						for(let a=0;a<list.length;a++){
							this.uploadImgParams.skuImages[i].image.push(list[a].url)
							console.log(this.uploadImgParams.skuImages[i].image)
						}
					}
				}
			},
			sendImg3(list){
				this.uploadImgParams.detailImgList = []
				for(let i=0;i<list.length;i++){
					this.uploadImgParams.detailImgList.push(list[i].url)
				}
			},
			submit_dialogUploadImg(){
				let params = this.uploadImgParams;
				console.log(params)
				let loading = this.$loading()
				this.$http.post(process.env.VUE_APP_baseData+'/api/product/goods/update/images', params).then(res => {
					loading.close()
					if (res.code == 0) {
						this.$message({
							message: '操作成功',
							type: 'success'
						});
						this.getTableData();
						this.dialogUploadImg_state = false;
					}
				})
			},
			// 获取列表
			changeSearch() {
				this.page.page = 1;
				this.getTableData();
			},
			changePage(val) {
				this.page.page = val;
				this.getTableData();
			},
			getTableData() {
				let params = {
					keyword: this.params.keyword,
					categoryId: this.params.categoryId,
					shopId: this.params.shopId,
					pageIndex:this.page.page,
					pageSize:this.page.pageSize,
				}
				this.$http.post(process.env.VUE_APP_baseData+'/api/product/goods/list', params).then(res => {
					if (res.code == 0) {
						this.tableData = res.data.data;
						this.page.total = res.data.count;
					}
				})
			},
			// 三级分类树
			getTree() {
				this.$http.get(process.env.VUE_APP_baseData+'/api/dict/ProductType/tree', {category: '商品'}).then(res => {
					if (res.code == 0) {
						this.categoryList = res.data[0].children;
						this.recursion(this.categoryList);
					}
				})
			},
			recursion(arr) {
				for (let i = 0; i < arr.length; i++) {
					if (arr[i].children == null || arr[i].children.length == 0) {
						arr[i].children = null;
					} else {
						this.recursion(arr[i].children);
					}
				}
			},
			renderContent(h, { node, data }) {
				return (
					<span  class="custom-tree-node" >
					<span>{node.label}</span>
					<span class='custom-tree-btn'>
					<el-button size="mini" type="text" icon = 'el-icon-plus' on-click={ () => this.addProductType(data) }></el-button>
					<el-button size="mini" type="text" icon = 'el-icon-edit' on-click={ () => this.editProductType(data) }></el-button>
					<el-button size="mini" type="text" icon = 'el-icon-delete' on-click={ () => this.delProductType(node, data) }></el-button>
					</span>
					</span>
				)   
			},
			clickProductType(data) {
				this.params.categoryId = data.id;
				this.getTableData();
			},
			resetProductType() {
				this.$refs.tree.setCurrentKey(null)
				this.params.categoryId = '';
				this.getTableData();
			},
			addProductType(data) {
				if (data) {
					this.editProductParams.typeId = '';
					this.editProductParams.typeName = '';
					this.editProductParams.parentId = data.id;
				} else {
					this.editProductParams.typeId = '';
					this.editProductParams.typeName = '';
					this.editProductParams.parentId = '602f1e89c904d9db7ccf3c03';
				}
				this.dialogProductType = true;
			},
			editProductType(data) {
				this.editProductParams.typeId = data.id;
				this.editProductParams.typeName = data.label;
				this.editProductParams.parentId = '';
				this.dialogProductType = true;
			},
			delProductType(node, data) {
				this.$confirm('请谨慎操作！此操作将永久删除此类型，那么关联此类型的服务将被波及?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.delete(process.env.VUE_APP_baseData+'/api/dict/ProductType', {id: data.id}).then(res => {
						if (res.code == 0) {
							this.$message({
								type: 'success',
								message: '删除成功!'
							});
							this.getTree();
						}
					})
				})
			},
			submitProductType() {
				if (!this.editProductParams.typeName) {
					this.$message({
						type: 'warning',
						message: '类型名称不能为空'
					});
				} else {
					this.$http.post(process.env.VUE_APP_baseData+'/api/dict/ProductType/update', this.editProductParams).then(res => {
						if (res.code == 0) {
							this.$message({
								type: 'success',
								message: '设置成功'
							});
							this.dialogProductType = false;
							this.getTree();
						}
					})
				}
			},
		},
	}
</script>

<style lang="scss" scoped>
	.page {
		padding: 16px 16px 0px 16px;
		height: 100%;
		box-sizing: border-box;
		position: relative;
		.screenLine {
			display: flex;
			.screenLineR{
				flex: 1;
				display: flex;
				justify-content: flex-end;
				.tabView{
					display: flex;
					align-items: center;
					width: 278px;
					height: 44px;
					background: #E7E7F4;
					border-radius: 10px;
					justify-content: space-around;
					.tabItem{
						width: 90px;
						height: 36px;
						font-size: 14px;
						text-align: center;
						line-height: 36px;
						border-radius: 8px;
					}
					.tabActiveItem{
						width: 90px;
						height: 36px;
						font-size: 14px;
						text-align: center;
						line-height: 36px;
						border-radius: 8px;
						background: #3A6DFF;
						color: #fff;
					}
				}
			}
			.titleSelect{
				width: 130px;
				margin-right: 16px;
			}
		}

		.pageConBox {
			margin-top:12px;
			display: flex;
			border-top: 1px solid #F2F2F2;
			height: calc(100% - 65px);

			.left {
				width: 200px;
				background-color: #fff;
				margin-right: 13px;
				box-sizing: border-box;
				padding: 10px;
				flex-shrink: 0;
				&::-webkit-scrollbar {
					width: 4px;
					// height: 4px;
				}
				.elTree{
					font-size: 12px;
					::v-deep .custom-tree-node{
						flex: 1;
						display: flex;
						align-items: center;
						justify-content: space-between;
						font-size: 12px;
						padding-right: 8px;
					}
					::v-deep .custom-tree-btn{
						display: none;
					}
					::v-deep .custom-tree-node:hover .custom-tree-btn{
						display: block;
					}
				}
			}

			.table {
				width:100%;
				position: relative;
				.tableBox {
					height: calc(100% - 60px);
				}
				.pagePosi {
					position: absolute;
					bottom: 0;
					left: 0px;
					right: 0px;
					text-align: right;
					background-color: #fff;
					padding: 0 10px;
					border-radius: 8px 8px 0 0;
				}
			}
		}
	}
</style>
